export default class LocalStorage {
	static get(key: string, defaultValue: any = null) {
		if (!key) throw new Error('Passed empty parameter key')
		const value = window.localStorage.getItem(key)
		if (!value) return defaultValue
		try {
			const parsedValue = JSON.parse(value)
			return parsedValue
		} catch (e) {
			return value
		}
	}
	static set(key: string, value: string | object = '') {
		if (!key) throw new Error('Passed empty parameter key')
		if (typeof value == 'object') value = JSON.stringify(value)
		window.localStorage.setItem(key, value)
	}
	static remove(key: string) {
		if (!key) throw new Error('Passed empty parameter key')
		window.localStorage.removeItem(key)
	}
	static clear() {
		window.localStorage.clear()
	}
}

export { LocalStorage }
